import React, { useState } from 'react'
import { Paper, SimpleGrid, Text, Checkbox,  PasswordInput, Progress, Box, Popover, Group } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useUserGeneralFormContext } from '../hook/user-general-form'
import UniqueRequired from '../../../../../ui/UniqueRequired'

const requirements = [
  { 
    re: /[0-9]/,
    label: 'Includes number'
  },
  { 
    re: /[a-z]/,
    label: 'Includes lowercase letter'
  },
  {
    re: /[$&+,:;=?@#|'<>.^*()%!-]/, 
    label: 'Includes special symbol' 
  },
]

function getStrength(form) {
  let multiplier = form.length > 0 ||  form === '' ? 0 : 1

  requirements.forEach((requirement) => {
    if (!requirement.re.test(form)) {
      multiplier += 1
    }
  })

  return Math.max(100 - (100 / (requirements.length + 1)) * multiplier, 10)
}

const UserChangePassword = () => {
  const form = useUserGeneralFormContext()
  const [visible, { toggle }] = useDisclosure(false)
  const [popoverPassword, setPopoverPassword] = useState(false)

  form.watch('change_password', ({ value }) => {
    if (!value) {
      form.setValues((prev) => ({ ...prev, password: '', password_confirmation: '' }))
    }
  })

  const checkPassword = requirements.map((val, index) => (
    <UniqueRequired key={index} label={val.label} meets={val.re.test(form.getValues().password)} />
  ))
  const strengthPassword = getStrength(form.getValues().password)

  const progressPassword = Array(3).fill(0).map((_, index) => {
    return (
      <Progress
        styles={{ section: { transitionDuration: '0ms' }}}
        value={Object.values(form.getValues().password).length > 0 && index === 0 ? 100 : strengthPassword >= ((index + 1) / 3) * 100 ? 100 : 0}
        color={strengthPassword > 60 ? 'teal' : strengthPassword > 50 ? 'yellow' : 'red'}
        key={index}
        size={3}
      />
    )
  })

  return (
    <Paper my='xl' p='md' withBorder shadow='xs' radius='md'>
      <Text fw={500}>
        Change Password
      </Text>
      <Checkbox
        my='md'
        size='xs'
        label="Change Password"
        key={form.key('change_password')}
        {...form.getInputProps('change_password', { type: 'checkbox' })}
      />
      <SimpleGrid my='xs' cols={4} spacing='lg' verticalSpacing='lg'>
        <Box>
          <Popover opened={popoverPassword} position="bottom" width="target" transitionProps={{ transition: 'pop' }}>
            <Popover.Target>
              <Box onFocusCapture={() => setPopoverPassword(true)} onBlurCapture={() => setPopoverPassword(false)}>
                <PasswordInput
                  label='New Password'
                  key={form.key('password')}
                  {...form.getInputProps('password')}
                  size='xs'
                  disabled={!form.getValues().change_password}
                  visible={visible}
                  onVisibilityChange={toggle}
                />
              </Box>
            </Popover.Target>
            <Popover.Dropdown>
              <Group gap={5} grow mt="xs" mb="md">
                {progressPassword}
              </Group>
              {checkPassword}
            </Popover.Dropdown>
          </Popover>
        </Box>

        <Box>
          <PasswordInput
            label='Confirmation New Password'
            key={form.key('password_confirmation')}
            {...form.getInputProps('password_confirmation')}
            size='xs'
            disabled={!form.getValues().change_password}
            visible={visible}
            onVisibilityChange={toggle}
          />
        </Box>
      </SimpleGrid>
    </Paper>
  )
}

export default UserChangePassword